<template>
  <div class="app-container">
    <PageTitle title="派单记录" ref="pageTitle" v-model="listQuery.city" @onChange="changeCity" />
    <div class="filter-container">
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入订单编号"
        v-model="listQuery.ota_sn"
        @change="handleOtaSn"
      ></el-input>
      <el-date-picker
        v-model="listQuery.use_date"
        type="date"
        placeholder="出发日期"
        value-format="yyyy-MM-dd"
        style="margin: 0 10px 10px 0; vertical-align: middle; width: 160px"
        @change="handleUseDate"
      ></el-date-picker>
      <TimeSelect
        @changeInterval="handleInterval"
        v-model="listQuery.interval_time"
        customStyle="margin: 0 10px 10px 0; vertical-align: middle; width: 160px"
      />
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入项目名称"
        v-model="listQuery.project_name"
        @change="handleProjectName"
      ></el-input>

      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="联系人手机号"
        v-model="listQuery.contact_mobile"
        @change="handleContactMobile"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="联系人姓名"
        v-model="listQuery.contact_name"
        @change="handleContactName"
      ></el-input>

      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.trip_type"
        placeholder="订单类型"
        @change="handleTripType"
      >
        <el-option label="拼团" :value="1"></el-option>
        <el-option label="包团" :value="2"></el-option>
      </el-select>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="导游手机号"
        v-model="listQuery.guide_mobile"
        @change="handleGuideMobile"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="导游姓名"
        v-model="listQuery.guide_name"
        @change="handleGuideName"
      ></el-input>

      <el-button
        class="filter-item"
        type="primary"
        plain
        icon="el-icon-refresh-left"
        @click="handleReset"
        >重置</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-button
      v-if="sendBtnShow"
      type="primary"
      size="mini"
      @click="sedMessage('')"
      style="margin-bottom: 10px"
      >批量发送微信消息</el-button
    >
    <Table :data="list" :columns="columns" :loading="listLoading" @changeSelect="changeSelect">
      <template v-slot:selection>
        <el-table-column width="50" align="center" type="selection" :selectable="checkSelectable">
        </el-table-column>
      </template>
      <template v-slot:interval_time>
        <el-table-column label="场次" width="100" align="center">
          <template slot-scope="scope"> {{ scope.row.interval_time }}场 </template>
        </el-table-column>
      </template>
      <template v-slot:contact>
        <el-table-column label="联系人" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.contact.name }}｜{{ scope.row.contact.mobile }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:trip_type>
        <el-table-column label="订单类型" width="100" align="center">
          <template slot-scope="scope"> {{ ['', '拼团', '包团'][scope.row.trip_type] }} </template>
        </el-table-column>
      </template>
      <template v-slot:guide>
        <el-table-column label="导游" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.guide.name }}｜{{ scope.row.guide.mobile }}
          </template>
        </el-table-column>
      </template>

      <template v-slot:add_time>
        <el-table-column label="派单时间" width="160" align="center">
          <template slot-scope="scope">
            <el-link type="info" :underline="false">{{ scope.row.add_time }}</el-link>
          </template>
        </el-table-column>
      </template>
      <template v-slot:is_arrived>
        <el-table-column label="客户状态" width="160" align="center">
          <template slot-scope="scope">
            <el-link type="info" :underline="false">{{
              scope.row.is_arrived ? '已到达' : '未到达'
            }}</el-link>
          </template>
        </el-table-column>
      </template>

      <template v-slot:send_status>
        <el-table-column label="短信状态" width="100" align="center">
          <template slot-scope="scope">
            {{ ['', '未发送', '已发送'][scope.row.send_status] }}
          </template>
        </el-table-column>
      </template>

      <template v-slot:action>
        <el-table-column label="操作" minWidth="260" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.can_cancel_assign"
              type="primary"
              size="mini"
              @click="handleCancel(scope.row.trip_service_id)"
              style="margin-left: 0; margin-right: 10px"
              >取消派单</el-button
            >
            <el-button
              v-if="scope.row.send_status == 1"
              type="primary"
              size="mini"
              @click="sedMessage(scope.row.trip_service_id)"
              style="margin-left: 0; margin-right: 10px"
              >发送微信消息</el-button
            >
            <el-button
              v-if="!scope.row.is_arrived"
              type="primary"
              size="mini"
              @click="handleArrive(scope.row.trip_service_id)"
              style="margin-left: 0; margin-right: 10px; margin-top: 10px"
              >确认到达</el-button
            >
            <el-button
              v-if="scope.row.has_device_data"
              type="primary"
              size="mini"
              plain
              @click="handleDeviceData(scope.row)"
              style="margin-left: 0; margin-right: 10px; margin-top: 10px"
              >录音和位置</el-button
            >
          </template>
        </el-table-column>
      </template>
    </Table>
    <DeviceDataDialog ref="deviceDataDialog" />
    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
  </div>
</template>

<script>
import { getList, cancel, send, sendBatch, arriveConfirm } from '@/api/assignRecord'
import PageTitle from '@/components/PageTitle'
import TimeSelect from '@/components/TimeSelect'
import DeviceDataDialog from './components/DeviceDataDialog'
export default {
  name: 'assignRecord',
  components: {
    PageTitle,
    TimeSelect,
    DeviceDataDialog
  },
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        city: '',
        ota_sn: '',
        contact_mobile: '',
        contact_name: '',
        project_name: '',
        trip_type: '',
        guide_name: '',
        guide_mobile: '',
        interval_time: ''
      },
      service_ids: [],
      sendBtnShow: false,
      columns: [
        { type: 'selection', slot: 'selection' },
        {
          label: '订单编号',
          width: '150',
          prop: 'ota_sn'
        },
        {
          label: '数量',
          width: '80',
          prop: 'user_num',
          align: 'center'
        },
        {
          label: '出发日期',
          width: '120',
          prop: 'use_date',
          align: 'center'
        },

        {
          label: '场次',
          slot: 'interval_time'
        },
        {
          label: '项目',
          width: '120',
          prop: 'project_name',
          showOverflowTooltip: true
        },
        {
          label: '联系人',
          slot: 'contact'
        },
        {
          label: '订单类型',
          slot: 'trip_type'
        },
        {
          label: '导游信息',
          slot: 'guide'
        },

        {
          label: '派单时间',
          slot: 'add_time'
        },
        {
          label: '确认到达时间',
          width: '160',
          prop: 'arrived_time',
          align: 'center'
        },
        {
          label: '客户状态',
          slot: 'is_arrived'
        },
        {
          label: '短信状态',
          slot: 'send_status'
        },
        {
          label: '操作',
          slot: 'action'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.listQuery.city = this.$refs.pageTitle.city
  },
  methods: {
    // 获取数据
    fetchData() {
      this.listLoading = true
      const query = { ...this.listQuery }
      if (query.pay_time && query.pay_time.length) {
        query.pay_time_start = query.pay_time[0]
        query.pay_time_end = query.pay_time[1]
      }
      getList(query).then((res) => {
        this.list = res.data.results
        this.count = res.data.count
        this.listLoading = false
      })
    },
    /**
     * @description: 选择城市
     * @param {*} e
     * @return {*}
     */
    changeCity(e) {
      this.listQuery.city = e
      this.handleFilter()
    },
    // 筛选
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
    handleOtaSn(e) {
      this.listQuery.ota_sn = e
      this.handleFilter()
    },
    handleUseDate(e) {
      this.listQuery.use_date = e
      this.handleFilter()
    },
    handleInterval(e) {
      this.listQuery.interval_time = e
      this.handleFilter()
    },
    handleProjectName(e) {
      this.listQuery.project_name = e
      this.handleFilter()
    },
    handleContactMobile(e) {
      this.listQuery.contact_mobile = e
      this.handleFilter()
    },
    handleContactName(e) {
      this.listQuery.contact_name = e
      this.handleFilter()
    },
    handleTripType(e) {
      this.listQuery.trip_type = e
      this.handleFilter()
    },
    handleGuideMobile(e) {
      this.listQuery.guide_mobile = e
      this.handleFilter()
    },
    handleGuideName(e) {
      this.listQuery.guide_name = e
      this.handleFilter()
    },
    /**
     * @description:重置
     * @return {*}
     */
    handleReset() {
      this.listQuery = {
        page: 1,
        size: 10,
        city: 1,
        ota_sn: '',
        contact_mobile: '',
        contact_name: '',
        project_name: '',
        trip_type: '',
        guide_name: '',
        guide_mobile: ''
      }
      this.fetchData()
    },
    /**
     * @description: 选择行
     * @return {*}
     */
    changeSelect(e) {
      this.sendBtnShow = !!e.length > 0
      console.log('changeSelect', e)
      this.service_ids = e.map((item) => item.trip_service_id)
    },
    /**
     * @description: 取消派单
     * @return {*}
     */
    handleCancel(trip_service_id) {
      this.$confirm('确认取消该订单的派单么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          cancel({ trip_service_id }).then(() => {
            this.$notify({
              title: '成功',
              message: '取消成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    },
    handleDeviceData(row) {
      this.$refs.deviceDataDialog.open(row.guide_service_id)
    },

    /**
     * @description: 确认到达
     * @return {*}
     */
    handleArrive(trip_service_id) {
      this.$confirm('是否确认游客已到达？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          arriveConfirm({ trip_service_id }).then(() => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    },
    /**
     * @description: 判断是否可选
     * @return {*}
     */
    checkSelectable(row) {
      return !!row.send_status == 1
    },
    /**
     * @description: 发送短信
     * @return {*}
     */
    sedMessage(trip_service_id) {
      const _this = this

      this.$confirm(`确认${trip_service_id == '' ? '批量' : ''}发送微信消息吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const p = trip_service_id
            ? send({ service_id: trip_service_id })
            : sendBatch({ service_ids: _this.service_ids })
          p.then(() => {
            this.fetchData()
            this.$parent.$notify({
              title: '成功',
              message: '消息发送成功',
              type: 'success'
            })
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.filter-container {
  justify-content: flex-start !important;
  flex-wrap: wrap;
}
</style>
